//-------React/Redux
import React from 'react';

//-------Components
import { Icon } from 'semantic-ui-react';

export const TagItem = (props) => {
  return (
    <div className="tag-item-container">
      <label className="tag-item-title">
        {props.label}
        <Icon
          name="remove circle"
          size="large"
          onClick={() => props.onDelete(props.index)}
        />
      </label>
    </div>
  );
};
